<template>
	<div class="content-main">
		<div class="Suplo" v-if="isck">
			<Gckfiles :upfiles="Supfiles" @close="isck=false" :Stype='stype' :Szlcontent="zlcontent">
			</Gckfiles>
		</div>
		<!-- 项目类别编辑弹窗 -->
		<Sprjtype @close='isxz=false' v-if="isxz" @editg='editclass'></Sprjtype>
		<!-- 资料上传弹窗 -->
		<Supziliao v-if="iszl" :ziliaoprj="ziliaoprj" :projectName="project.projectName" @close="iszl=false"
			:del="Sdel"></Supziliao>

		<!-- 左侧项目列表 -->
		<div class="content-left">
			<div class="left-tou">{{ Smenuname }}</div>
			<div class="left-center">
				<div class="left-list" v-for="(s, index) in Sshowlist" :key="index"
					:class="{ 'mingxi-content1': s.projectId == zyindex }" @click="zyindex=s.projectId; Ezlqd(s)"
					:title="s.projectName">
					{{prjectsl(s.projectName,15)}}
				</div>
			</div>
		</div>

		<!-- 右侧项目详情 -->
		<div class="content-center">
			<div class="zlqd-tou">
				<div class="zlqd-title" style="cursor: pointer" :title="project.projectName || '未选择'">
					项目名称：{{project.projectName?prjectsl(project.projectName,35):'未选择'}}</div>

				<div class="zlqd-jiage1">
					<span v-if="project.engineerUserName" class="gcscp">
						<div class="gcscat">工程师：{{project.engineerUserName}}
							<img src="../../assets/对话.png" style="height: 20px;width: 20px;"
								v-if="project.engineerUserName" @click="ischat()" />
							<el-tooltip :content="project.engineerPhone" placement="top"
								v-if="project.engineerUserName">
								<img src="../../assets/电话.png" style="height: 20px;width: 20px;" />
							</el-tooltip>

						</div>
						<el-tooltip class="box-item" effect="dark" content="差评" placement="top"
							v-if="!project.evaluateEngineerUserIds?.includes(project.engineerUserId)">
							<img src="../../assets/差评.png" class="cpimg" @click="Schap()" />
						</el-tooltip>
						<el-tooltip class="box-item" effect="dark" content="撤消差评" placement="top" v-else>
							<img src="../../assets/差评1.png" class="cpimg" @click="Sdelchap()" />
						</el-tooltip>
					</span>
				</div>
			</div>
			<div class="zlqd-list">
				<!-- 项目基础信息表单 -->
				<div class="zlqd-content">
					<div class="name-list">
						<div class="name">
							<div class="title">委托人：</div>
							<div class="xm-content" :class="{'xm-content1':ists}">{{wtrts()}}</div>
						</div>
						<div class="name">
							<div class="title">项目类别：</div>
							<div class="xm-content">{{Sclass()}} </div>
						</div>
						<div class="name">
							<div class="title">项目价格：</div>
							<div class="xm-content">{{xmjg()}}</div>
						</div>
						<div class="name">
							<div class="title">项目名称：</div>
							<div class="xm-content">
								{{prjname}}
							</div>
						</div>
						<div class="name">
							<div class="title">编制期限：</div>
							<div class="xm-content" v-if="bzqx!=null">
								{{bzqx=='0'?'加急'+Math.ceil(bz.prepareCycle/2)+'天':bz.prepareCycle+'天'}}

							</div>
						</div>

						<div class="name">
							<div class="title">建设性质：</div>
							<div class="xm-content">
								{{jsxz}}

							</div>
						</div>
						<div class="name">
							<div class="title">建设周期：</div>
							<div class="xm-content">
								{{zq()}}
							</div>
						</div>
						<div class="name" @click="Sckfiles">
							<span class="title">成果文件：</span>
							<img src="../../assets/成果.png" style="height: 18px;width: 18px;" class="tc-img"
								v-if="project.resultData" />
						</div>
						<div class="name">
							<div class="title">其他说明：</div>

						</div>
						<div class="name">
							<div class="xm-content1">
								{{project.description}}
							</div>
						</div>
					</div>
				</div>

				<!-- 资料清单 -->
				<div class="zlqd-content">
					<div class="zlqd-Stile">资料清单
						<div class="tools" v-if="JSON.stringify(project)!=='{}'">

							<el-button size="mini" type="text" @click="upfile(project)">
								<i class="el-icon-upload"></i>
								查看上传资料
							</el-button>
						</div>
					</div>
					<div class="zlqd-li">
						<div class="zlqd-contitle" v-for="(item, ind) in zllist" :key="ind">
							{{ ind + 1 }}.{{ item.informationTypeName }}

							<!-- <div class="upshuoming" v-if="item.Snum" @click="ckzl(item)">
								<span class="uptext">{{item.Snum}}</span>
							</div> -->
						</div>
					</div>
				</div>
			</div>
			<div class="content-center-z" v-if="isbz"></div>
		</div>
	</div>
</template>

<script>
	// 仅保留核心接口（项目编辑、资料查询/上传、类别查询）
	import {
		zyemg,
		subclass,
		editPRJ,
		addzl,
		editxmzl,
		chap,
		delchap,
		ALLprj
	} from "../../utils/request.js";
	// 保留所有使用的子组件
	import Gckfiles from "./Gckfiles.vue";
	import Ssqbz from "./Ssqbz.vue";
	import Supziliao from "./Supziliao.vue";
	import Sprjtype from "./Sprjtype.vue";
	// 保留缓存工具（获取项目类别、用户名）
	import {
		Getitem
	} from "../../utils/item.js";

	export default {
		props: {

			// 父组件传递的菜单名称（如“未开始项目”）
			Smenuname: {
				type: String,
				default: '' // 修复props默认值写法
			}
		},
		data() {
			return {
				// -------------------------- 核心业务变量 --------------------------
				zyindex: -1, // 当前选中sendid（左侧列表高亮用）
				prjtype: Getitem('setmenu'), // 所有项目类别（缓存获取）
				prjname: '', // 当前项目名称（表单绑定）
				bz: {}, // 项目类别配置（含价格、周期、系数）
				isxz: false, // 项目类别弹窗显示状态
				project: {}, // 当前选中项目完整信息
				files: [], // 当前项目的原始资料列表
				Sprojectid: '', // 当前sendid（资料操作用）
				zllist: [], // 当前项目的资料清单（右侧展示用）
				isbz: false, // 备用弹窗控制（保留原逻辑）
				ists: false, // 委托人登录警告样式控制
				bzqx: null, // 编制期限（1正常/0加急）
				jsxz: '', // 建设性质（默认新建）
				content: '', // 其他说明（文本域绑定）
				name: Getitem('name'), // 登录用户名（缓存获取）
				stardate: '', // 建设开始日期（日期选择器绑定）
				enddate: '', // 建设结束日期（日期选择器绑定）
				iszl: false, // 资料上传弹窗显示状态
				ziliaoprj: {}, // 传递给资料弹窗的当前资料项
				discipline: '', // 项目类别名称（格式化显示用，如“可行性研究报告”）
				isck: false,
				Supfiles: [],
				stype: "",
				zlcontent: '',
				cycjiaji: 0,
				Sshowlist: [],
				Sdel: '1'
			};
		},
		components: {
			Ssqbz,
			Supziliao,
			Sprjtype,
			Gckfiles
		},
		created() {
			this.allprj()
		},
		methods: {
			upfile(project) {
				this.ziliaoprj = JSON.parse(project.informationUrls) || []
				this.iszl = true

			},
			prjectsl(e, num) {
				if (e.length > num) {
					const res = e.slice(0, num);
					return `${res}...`
				} else {
					return e
				}
			},
			async allprj() {
				const res = await ALLprj();
				if (res.code === 200) {
					let pros = res.list;
					// 解析项目中的资料文件（Files字段为JSON字符串，转成数组）
					pros.forEach(r => {
						r.information = r.information || [];
						r.information.forEach(d => {
							d.Files = JSON.parse(d.Files || '[]');
						});
					});
					this.Sshowlist = pros.filter(item => item.finishFlag === '2');
					// console.log(this.prjlist);
				} else {
					this.$toast.error(res.msg || '获取项目列表失败');
				}
			},

			ischat() {
				let data = {
					toid: this.project.engineerUserId,
					toname: this.project.engineerUserName,
					myname: this.name,
					myid: Getitem('userid'),
					toclass: 'eng'
				}
				this.$store.commit('setgochat', data)
			},
			async Sdelchap() {
				let data = {
					engineerUserId: this.project.engineerUserId,
					projectId: this.project.projectId
				}
				let s = await delchap(data)
				if (s.code === 200) {
					this.$toast.success('差评撤消完成')
					const index = this.project.evaluateEngineerUserIds.indexOf(this.project.engineerUserId);
					if (index !== -1) {
						this.project.evaluateEngineerUserIds.splice(index, 1); // 从索引index开始，删除1个元素
					}
					this.allprj()
				} else {
					this.$toast.error('差评撤消失败')
				}
			},
			async Schap() {
				let data = {
					engineerUserId: this.project.engineerUserId,
					projectId: this.project.projectId
				}

				let s = await chap(data)
				if (s.code === 200) {
					this.$toast.success('已给予差评')
					let s = this.project.evaluateEngineerUserIds || []
					s.push(this.project.engineerUserId)
					this.project.evaluateEngineerUserIds = s
					this.allprj()

				} else {

					this.$toast.error('差评未成功')
				}

			},
			ckzl(item) {
				this.Supfiles = item.Files
				this.stype = "资料"
				this.zlcontent = item.content
				this.isck = true

				// console.log(item.Files);
			},
			Sckfiles() {
				this.Supfiles = this.project.resultData ? JSON.parse(this.project.resultData) : []
				this.stype = "成果"
				this.zlcontent = ''
				this.isck = true
			},

			zq() {
				if (!this.stardate) return
				return this.stardate + '至' + this.enddate
			},
			/**
			 * 加载选中项目的资料列表，触发资料清单查询
			 * @param {Object} file - 选中的项目对象
			 */
			async Ezlqd(file) {
				this.files = await file.information;
				this.zllist = [];
				this.Szlcx(file);
			},

			/**
			 * 提交项目信息修改（完善/编辑）
			 * 含表单验证、接口提交、成功回调
			 */
			async editproject() {
				if (!this.prjname) {
					this.$toast.error('没有填写项目名称！');
					return;
				}
				if (!this.stardate || !this.enddate) {
					this.$toast.error('没有填写项目建设周期！');
					return;
				}
				const start = new Date(this.stardate).getTime();
				const end = new Date(this.enddate).getTime();
				if (start > end) {
					this.$toast.error('建设周期开始时间不能在结束时间之后！');
					return;
				}
				const data = {
					projectId: this.project.projectId,
					projectTypeId: this.project.projectTypeId,
					projectAmount: this.xmjg().replace('元', ''), // 价格转纯数字
					projectName: this.prjname,
					industryTypeId: this.project.industryTypeId,
					cycle: this.bzqx == 0 ? 0 : this.bz.prepareCycle,
					nature: this.jsxz,
					startDate: this.stardate,
					finishDate: this.enddate,
					description: this.content
				};
				const s = await editPRJ(data);
				if (s.code === 200) {
					this.$toast.success('修改成功');
					this.allprj()
				} else {
					this.$toast.error(s.msg);
				}
			},

			/**
			 * 接收项目类别弹窗的编辑结果，更新当前项目配置
			 * @param {Object} e - 编辑后的类别配置（含行业ID、价格、周期）
			 */
			async editclass(e) {
				this.project.industryTypeId = e.industryTypeId;
				this.project.projectTypeId = e.projectTypeId;
				// 计算项目价格（加急按系数）
				this.project.projectAmount = this.bzqx == 0 ? e.preparePrices * e.factor : e.preparePrices;
				// 计算编制周期（加急为0）
				this.project.cycle = this.bzqx == 0 ? 0 : e.prepareCycle;
				// 同步表单其他信息
				this.project.startDate = this.stardate;
				this.project.finishDate = this.enddate;
				this.project.description = this.content;
				this.project.nature = this.jsxz;
				this.project.projectName = this.prjname;
				// 重新查询项目资料清单
				this.Szlcx(this.project);
			},

			/** 显示项目类别编辑弹窗 */
			changeclass() {
				this.isxz = true;
			},

			/**
			 * 查询单个项目的详情（含类别匹配、周期/价格配置）
			 * @param {Object} E - 选中的项目对象
			 */
			async Szlcx(E) {
				this.project = Object.assign({}, E); // 深拷贝避免源数据污染
				this.Sprojectid = E.projectId;

				// 匹配项目类别名称（如“可行性研究报告”）
				this.prjtype.forEach(r => {
					r.list.forEach(n => {
						if (n.projectTypeId == E.projectTypeId) {
							this.discipline = n.projectType;
						}
					});
				});
				// 查询项目子类配置（价格、周期）
				const id = await this.cxgzmc(E);
				// 同步表单绑定值
				this.bzqx = E.cycle != 0 ? 1 : 0;
				this.prjname = E.projectName;
				this.jsxz = E.nature;
				this.stardate = E.startDate;
				this.enddate = E.finishDate;
				this.content = E.description;
				// 查询项目资料清单
				await this.Szllist(id);
			},

			/**
			 * 查询项目的子类明细（获取价格、周期、系数等配置）
			 * @param {Object} r - 项目对象（含项目类型ID）
			 * @returns {string} 子类ID（用于资料清单查询）
			 */
			async cxgzmc(r) {
				try {
					const res = await subclass(r.projectTypeId);
					if (res.code === 200 && res.list && res.list.length > 0) {
						// 筛选当前项目所属行业的配置
						const industryConfig = res.list.filter(e => e.industryTypeId == r.industryTypeId);

						if (industryConfig.length > 0) {
							this.bz = industryConfig[0];
							// console.log('项目配置信息:', this.bz);
							return this.bz.subclassId;
						} else {
							// 如果没有匹配的行业配置，使用第一个配置作为默认值
							// console.warn('未找到匹配的行业配置，使用默认配置');
							this.bz = res.list[0];
							return this.bz.subclassId;
						}
					} else {
						// console.error('获取项目子类配置失败:', res);
						this.$toast.error('获取项目配置失败');
						// 设置默认配置避免后续错误
						this.bz = {
							preparePrices: 0,
							factor: 1,
							prepareCycle: 0,
							industryTypeName: '未知',
							subclassId: ''
						};
						return '';
					}
				} catch (error) {
					// console.error('查询项目子类明细异常:', error);
					this.$toast.error('查询项目配置异常');
					// 设置默认配置避免后续错误
					this.bz = {
						preparePrices: 0,
						factor: 1,
						prepareCycle: 0,
						industryTypeName: '未知',
						subclassId: ''
					};
					return '';
				}
			},

			/**
			 * 查询当前项目的资料清单
			 * @param {string} id - 子类ID（系统资料模板查询用）
			 */
			async Szllist(id) {
				// 如果id为空，直接返回
				if (!id) {
					// console.warn('子类ID为空，无法查询资料清单');
					this.zllist = [];
					return;
				}

				try {
					const zlres = await zyemg(id);
					if (zlres.code === 200 && zlres.list) {
						const syszl = zlres.list;
						const su = [];

						// 使用Promise.all等待所有异步操作完成
						const promises = syszl.map(async (res) => {
							let suhua = {};

							// 在现有文件中查找匹配的资料
							if (this.files && this.files.length > 0) {
								this.files.forEach(item => {
									if (res.informationTypeId == item.informationTypeId) {
										let Snum = 0;
										if (item.content) Snum += 1;
										if (item.Files && item.Files.length > 0) Snum += item.Files
											.length;

										suhua = {
											informationTypeId: res.informationTypeId,
											informationTypeName: res.informationTypeName,
											Files: item.Files || [],
											content: item.content,
											examineFlag: item.examineFlag,
											projectId: item.projectId,
											projectInformationId: item.projectInformationId,
											updateTime: item.updateTime,
											Snum
										};
									}
								});
							}

							// 如果没有找到现有资料，初始化新资料记录
							if (JSON.stringify(suhua) === '{}') {
								suhua = {
									informationTypeId: res.informationTypeId,
									informationTypeName: res.informationTypeName,
									Files: [],
									content: null,
									examineFlag: "0",
									projectId: this.Sprojectid,
									projectInformationId: '',
									updateTime: "",
									Snum: 0
								};

								// 初始化资料记录到数据库
								try {
									const im = await addzl({
										projectId: this.Sprojectid,
										informationTypeId: res.informationTypeId,
										Files: JSON.stringify([]),
										content: ""
									});
									if (im.code !== 200) {
										// console.error('初始化资料记录失败:', im.msg);
									}
								} catch (error) {
									// console.error('初始化资料记录异常:', error);
								}
							}

							return suhua;
						});

						// 等待所有资料处理完成
						const results = await Promise.all(promises);
						this.zllist = results.filter(item => item); // 过滤掉空项
					} else {
						// console.error('查询资料清单失败:', zlres);
						this.$toast.error('查询资料清单失败');
						this.zllist = [];
					}
				} catch (error) {
					// console.error('查询资料清单异常:', error);
					this.$toast.error('查询资料清单异常');
					this.zllist = [];
				}
			},
			/**
			 * 处理资料上传后的更新（接收资料弹窗回调）
			 * 同步本地数据、调用接口更新、触发父组件刷新
			 * @param {Object} e - 上传后的资料项数据
			 */
			async shondanziliao(e) {
				// 重新计算已上传数量
				e.Snum = 0;
				if (e.content !== '') e.Snum += 1;
				e.Snum += e.Files.length;
				e.examineFlag = 0; // 重置审核状态为“审核中”

				// 同步本地资料清单和原始数据
				this.zllist.forEach((res, index) => {
					if (res.informationTypeId === e.informationTypeId) {
						this.zllist[index] = e;
						this.files[index] = e;
					}
				});

				// 调用接口更新资料
				const data = {
					projectId: e.projectId,
					projectInformationId: e.projectInformationId,
					informationTypeId: e.informationTypeId,
					Files: JSON.stringify(e.Files),
					content: e.content
				};
				const u = await editxmzl(data);
				if (u.code == 200) {
					this.allprj()
				} else {
					this.$toast.error(u.msg);
				}
			},


			xmjg() {
				if (JSON.stringify(this.bz) == '{}') return '';
				return this.bzqx != 0 ?
					`${this.bz.preparePrices}元` :
					`${this.bz.preparePrices * this.bz.factor}元`;
			},

			/**
			 * 接收日期选择器的日期范围，同步到本地变量
			 * @param {Object} range - 日期范围（含startDate/endDate）
			 */
			handleDateRangeChange(range) {
				this.stardate = range.startDate;
				this.enddate = range.endDate;
			},

			/**
			 * 格式化显示项目类别（如“可行性研究报告（工业类）”）
			 * @returns {string} 格式化后的类别名称
			 */
			Sclass() {
				if (JSON.stringify(this.bz) === '{}') return '';
				return `${this.discipline}（${this.bz.industryTypeName}）`;
			},

			/**
			 * 显示委托人信息（未登录时提示警告）
			 * @returns {string} 委托人名称或登录警告
			 */
			wtrts() {
				if (!this.name) {
					this.ists = true;
					return "你没有登录，无法委托，我们也无法为您发送成果！";
				} else {
					this.ists = false;
					return this.name;
				}
			},

			/** 备用方法：控制isbz弹窗（保留原逻辑，未实际调用） */
			sqbz() {
				this.isbz = true;
			}
		},
		computed: {
			/** 格式化显示项目类别（备用，保留原逻辑） */
			displayText() {
				return this.discipline ? this.discipline : "请选择类型";
			}
		}
	};
</script>

<style lang="less" scoped>
	/* 完全保留原有样式，无任何修改 */
	.content-main {
		height: 70vh;
		width: 100vw;
		margin-top: 15px;
		/* background-color: white; */
		display: flex;
		justify-content: start;
		align-items: center;

		.content-left {
			width: 15vw;
			height: 90%;
			background-color: #fdfdfd;
			border-radius: 10px;
			box-shadow: 0 5px 5px rgba(0, 0, 0, 0.6);
			margin-left: 15px;

			.left-tou {
				width: 85%;
				margin: auto;
				padding: 7px 7px 5px 7px;
				font-size: 17px;
				text-align: center;
				line-height: 35px;
				font-weight: bold;
				border-bottom: 1px solid #dfdfdf;
				margin-bottom: 5px;
			}

			.left-center {
				height: 87%;
				width: 92%;
				margin: 0 auto;
				display: flex;
				flex-direction: column;
				align-items: start;
				// justify-content: center;
				line-height: 30px;
				padding-top: 6px;
				padding-left: 10px;
				overflow: auto;
				scrollbar-width: none;
				-ms-overflow-style: none;


				.left-list {
					width: 100%;
					text-align: left;
					font-size: 13px;
					line-height: 30px;
					border-bottom: 1px dashed #dddddd;
					cursor: pointer;
					font-weight: 900;

					position: relative;
					display: inline-block;
				}

				.left-list::after {
					content: attr(data-tooltip);
					position: absolute;
					bottom: 100%;
					left: 50%;
					transform: translateX(-50%);
					background: rgba(0, 0, 0, 0.8);
					color: white;
					padding: 5px 10px;
					border-radius: 4px;
					font-size: 12px;
					white-space: nowrap;
					opacity: 0;
					visibility: hidden;
					transition: opacity 0.3s;
					z-index: 1000;
					pointer-events: none;
				}

				.left-list:hover {
					color: #409eff !important;
				}
			}
		}

		.content-center {
			width: 80vw;
			height: 63vh;
			background-color: #409eff;
			margin-left: 1.5vw;
			background-color: #fdfdfd;
			border-radius: 10px;
			box-shadow: 0 5px 5px rgba(0, 0, 0, 0.6);
			display: flex;
			flex-direction: column;
			align-content: center;
			justify-content: start;
			position: relative;

			.content-center-z {
				width: 80vw;
				height: 63vh;
				background-color: #409eff;
				// margin-left: 1.5vw;
				background-color: #fdfdfd;
				border-radius: 10px;
				box-shadow: 0 5px 5px rgba(0, 0, 0, 0.6);
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				z-index: 50;
			}

			.zlqd-tou {
				width: 78vw;
				height: 5.5vh;
				margin: 0 auto;
				display: flex;
				justify-content: start;
				align-items: center;
				font-weight: bold;
				font-size: 17px;
				border-bottom: 1px solid #dfdfdf;
				position: relative;

				.zlqd-title {
					padding-left: 15px;
					padding-top: 5px;
					position: relative;
					display: inline-block;

					.zlqd-title::after {
						content: attr(data-tooltip);
						position: absolute;
						bottom: 100%;
						left: 50%;
						transform: translateX(-50%);
						background: rgba(0, 0, 0, 0.8);
						color: white;
						padding: 5px 10px;
						border-radius: 4px;
						font-size: 12px;
						white-space: nowrap;
						opacity: 0;
						visibility: hidden;
						transition: opacity 0.3s;
						z-index: 1000;
						pointer-events: none;
					}

					.zlqd-title:hover::after {
						opacity: 1;
						visibility: visible;
					}

					/* 小箭头 */
					.zlqd-title::before {
						content: '';
						position: absolute;
						bottom: 100%;
						left: 50%;
						transform: translateX(-50%);
						border: 5px solid transparent;
						border-top-color: rgba(0, 0, 0, 0.8);
						opacity: 0;
						visibility: hidden;
						transition: opacity 0.3s;
						z-index: 1000;
						margin-bottom: -5px;
					}

					.zlqd-title:hover::before {
						opacity: 1;
						visibility: visible;
					}
				}

				.zlqd-jiage {
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					// width: 420px;
					display: flex;
					align-items: center;
					justify-content: space-between;
					font-size: 13px;
					padding-top: 5px;
					padding-right: 30px;

					.jiage {
						width: 140px;
					}
				}
			}

			.zlqd-list {
				width: 78vw;
				height: 54vh;
				margin: 0 auto;
				// background-color: #18688d;
				margin-top: 1.5vh;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.zlqd-content {
					width: 37.5vw;
					height: 53vh;
					background-color: rgba(233, 233, 233, 0.5);
					box-shadow: 0 2px 2px rgba(0, 0, 0, 0.6);
					border-radius: 0 0 10px 10px;
					padding: 8px;
					position: relative;

					.wt-but {
						position: absolute;
						bottom: 10px;
						left: 50%;
						transform: translate(-50%, -50%);
					}

					.zlqd-Stile {
						height: 3vh;
						width: 100%;
						font-size: 16px;
						font-weight: bold;
						text-align: start;
						border-bottom: 1px solid #dfdfdf;
						display: flex;
						position: relative;

						.tools {
							position: absolute;
							top: 50%;
							right: 10px;
							transform: translateY(-50%);
							display: flex;
							align-items: center;
							justify-content: center;
							gap: 15px;
							width: 150px;

							.downlist {
								font-size: 13px;
								display: flex;
								align-items: center;
								gap: 5px;
								cursor: pointer;
								padding: 4px 8px;
								border-radius: 4px;
								transition: all 0.3s;

								&:hover {
									background-color: #f0f0f0;
									color: #409eff;
								}

								.el-icon {
									font-size: 14px;
								}
							}
						}

						.zlqd-shuom {
							font-size: 13px;
							font-weight: 200;
							color: red;

							.Sblack {
								color: #606266;
							}
						}
					}

					.zlqd-li {
						height: 50vh;
						width: 100%;
						overflow: auto;
						scrollbar-width: none;
						-ms-overflow-style: none;


						.zlqd-contitle {
							// height: 3vh;
							display: flex;
							align-items: center;
							// justify-content: center;
							border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
							font-size: 13px;
							padding: 4px 0;

							text-align: left;
							position: relative;

							.upshuoming {
								position: absolute;
								top: 50%;
								right: -5px;
								transform: translate(-50%, -50%);
								display: flex;
								align-items: center;
								justify-content: end;

								.uptext {
									font-weight: bold;
									color: #409eff;
									margin -right: 10px;
									border: 1px solid #409eff;
									width: 16px;
									height: 16px;
									border-radius: 50%;
									display: flex;
									align-items: center;
									justify-content: center;
									cursor: pointer;
								}


							}


						}
					}

					.name-list {
						margin: auto;
						width: 36vw;
						height: 52vh;
						line-height: 40px;
						display: flex;
						flex-direction: column;
						justify-content: start;
						align-items: start;
						padding: 10px 15px;

						.name {
							font-size: 15px;
							line-height: 40px;
							padding: 5 10px;
							text-align: left;
							display: flex;
							align-items: center;
							justify-content: start;


							.title {
								width: 80px;
								text-align: right;
							}

							.titlesf {
								width: 80px;
								display: flex;
								align-items: flex-start;
							}

							.xm-content1 {
								padding: 2px 0;
								font-weight: 200 !important;

							}

							.xm-content {
								// font-weight: bold;
								position: relative;
								display: flex;
								align-items: center;
								position: relative;
								cursor: pointer;

								.content-icon {
									position: absolute;
									top: -5px;
									right: -5px;
									width: 30px;
									height: 30px;
									font-size: 20px;
									color: #d5d5d5;
									cursor: pointer;
								}

								.Sqixian {
									font-weight: 100;
									padding-left: 15px;
									font-size: 18px;
									color: red;
									display: flex;
									align-items: center;

									.Sastar {
										padding-top: 7px;
									}

									.sl {
										font-size: 12px;
										color: #606266
									}
								}

								.input-control {
									width: 30vw;
									height: 40px;
									padding: 0 25 0 5px;
									padding-right: 40px;
									padding-left: 10px;
									border: 1px solid #dcdfe6;
									border-radius: 4px;
									font-size: 14px;
									color: #606266;
									transition: border-color 0.2s;
									box-sizing: border-box;
									background: #fff;
									position: relative;
									z-index: 2;


									&:focus {
										border-color: #409eff;
										outline: none;
									}
								}

								.clear-icon {
									font-size: 20px;
									width: 25px;
									height: 40px;
									position: absolute;
									top: 50%;
									left: 29vw;
									transform: translate(-50%, -50%);
									z-index: 30;
									cursor: pointer;
									color: #d5d5d5;

								}
							}

							.xm-content1 {
								font-size: 12px;
								color: red;
							}


						}
					}

				}
			}
		}
	}

	.msg {
		width: 100vw;
		height: 10vh;
		display: flex;
		justify-content: center;
		align-items: center;
		padding-top: 20px;
		background-color: #fdfdfd;
		height: 15vh;
		box-shadow: 0 5px 5px -1px rgba(0, 0, 0, 0.6);

		.msg-main {
			/* display: flex; */
			position: relative;

			.msg-menu {
				display: flex;
				// flex-direction: column;
				align-items: center;
				justify-content: space-between;
				margin: 0 40px;
				color: #18688d;
				font-size: 15px;
				// font-weight: 700;
				// width: 30vw;

				.msg-img {
					width: 110px;
					height: 80px;
					// border-radius: 50%;
					// border: 1px solid #454962;
					// background-color: #e5e5e5;
					// box-shadow: 0 5px 16px rgba(0, 0, 0, 0.6);
					margin-bottom: 10px;

					filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.3));
				}

				.msg-img1 {
					width: 160px;
					height: 120px;

					// border-radius: 50%;
					// border: 1px solid #454962;
					// background-color: #e5e5e5;
					filter: drop-shadow(0px 0px 0px rgba(0, 0, 0, 0));
					margin-bottom: 10px;

				}
			}

			.mingxi {
				position: absolute;
				top: 100%;
				left: 0;
				right: 0;
				margin: 0 auto;
				/* 关键：横向居中 */
				/* bottom: 0; */
				z-index: 100;
				font-size: 13px;
				line-height: 25px;
				border: 1px solid #d5d5d5;
				border-radius: 5px;
				display: flex;
				flex-direction: column;
				align-items: start;
				padding: 10px;
				background-color: #e5e5e5;
				box-shadow: 0 2px 2px rgba(0, 0, 0, 0.6);
				cursor: pointer;

				/* font-size: 12px; */
			}
		}
	}

	@keyframes bounce {

		0%,
		100% {
			transform: translateY(0);
		}

		50% {
			transform: translateY(-10px);

		}
	}

	.msg .msg-menu {
		transition: transform 0.3s ease;
	}

	.msg .msg-menu:hover {
		animation: bounce 0.5s ease;
		cursor: pointer;

	}

	.mingxi-content1 {
		padding-left: 6px;
		background-color: rgba(64, 158, 255, 0.3) !important;
		color: #333 !important;
		// font-weight: bold;
	}

	.a {
		width: 100vw;
		height: 60vh;
		position: absolute;
		top: 0;
		left: 0;
		background-color: aliceblue;
		z-index: 999;

	}

	.zlqd-jiage1 {
		position: absolute;
		top: 50%;
		right: 5px;
		transform: translate(-50%, -50%);
		font-size: 16px !important;
		// width: 420px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 13px;
		padding-top: 5px;
		padding-right: 30px;
	}

	.xm-content1 {
		width: 35vw;
		height: 10vh;
		border-radius: 5px;
		padding: 5px !important;
		// background-color: white;
		font-size: 13px !important;
		color: #333 !important;
		line-height: 25px;
		border: 1px solid #d0d0d0;
		overflow-y: auto;
		scrollbar-width: none;
		-ms-overflow-style: none;

	}

	.Suplo {
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background-color: rgba(0, 0, 0, 0.3);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 400;
	}

	.gcscp {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 50px;
		cursor: pointer;
	}

	.cpimg {
		width: 20px;
		height: 20px;
		filter: drop-shadow(1px 3px 1px rgba(0, 0, 0, 0.3));
	}

	.cpimg:hover {
		filter: none;
		padding-top: 5px;
	}

	.gcscat {
		display: flex;
		justify-content: left;
		align-items: center;
		gap: 15px;
	}
</style>